import React, { useRef } from "react";
import "./Connect.css";
import emailjs from "@emailjs/browser";

const Connect = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_i258nk4",
        "template_awaqjbb",
        form.current,
        "vjDrkPq3c3bd37dV6"
      )
      .then(
        () => {
          console.log("SUCCESS!");
        },
        (error) => {
          console.log("FAILED...", error.text);
        }
      );
  };
  return (
    <div className="connect" id="connect-us">
      <div className="left-c">
        <hr />
        <div>
          <span className="stroke-text">READY TO</span>
          <span>LEVEL UP</span>
        </div>
        <div>
          <span>YOUR BODY</span>
          <span className="stroke-text">WITH US?</span>
        </div>
      </div>
      <div className="right-c">
        <form ref={form} className="email-container" onSubmit={sendEmail}>
          <input
            type="email"
            name="user_email"
            placeholder="Enter your email address to join"
          />
          <button className="btn btn-c">Join Now</button>
        </form>
      </div>
    </div>
  );
};

export default Connect;
